import { css } from '@emotion/react'
import { ThemeUI } from '../../../theme'
import { StyleProps } from './types'

type Props = { theme: ThemeUI } & StyleProps

export const rootContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 18px;
`

export const label = ({ theme }: Props) => css`
  font-size: 11px;
  line-height: 14px;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.04em;
`

export const hint = ({ theme, success, error }: Props) => css`
  font-size: 11px;
  line-height: 14px;
  margin-top: 6px;
  text-align: right;
  ${success && `color: ${theme.palette.success};`}
  ${error && `color: ${theme.palette.danger};`}
`

export const input = ({ disabled }: Props) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  box-sizing: border-box;
  padding: 18px;
  width: 100%;
  min-height: 84px;
  background-color: #ffffff;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  line-height: 20px;
  border-radius: 16px;
  border: 1px dashed #b7a7ff;
  color: #0f172a;
  transition: all 0.18s ease;

  &:hover {
    cursor: pointer;
    background: #faf8ff;
    border-color: #34189a;
  }

  & span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #475569;
  }

  ${disabled && `
    background-color: #f8fafc;
    cursor: not-allowed;
  `}
`